import { render, staticRenderFns } from "./indic-card-tab.vue?vue&type=template&id=3c9218e0&"
import script from "./indic-card-tab.vue?vue&type=script&lang=ts&"
export * from "./indic-card-tab.vue?vue&type=script&lang=ts&"
import style0 from "./indic-card-tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports